import React from "react";
import PropTypes from "prop-types";

import { scrollToResultsTop } from "wxrecall/util/util";

import "wxrecall/components/SearchResults/ScrollToTop.css";

/**
 * Renders a control which scrolls the page back up to the top when clicked
 */
const ScrollToTopButton = props => (
  <button
    data-tip
    data-for="scroll_button_tooltip"
    className={`btn scroll-to-top-button ${props.mobile ? "hide" : ""}`}
    onClick={scrollToResultsTop}
  >
    <i className="icon-arrow-up" />
  </button>
);

ScrollToTopButton.propTypes = {
  // True if the page is in mobile mode. Used to style the button.
  mobile: PropTypes.bool
};

export default ScrollToTopButton;
